import TableLayout, {
  TableNullState,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';
import { formatDollar, formatNumber } from 'dashboard/lib/utils/formatters';
import { Invoice, InvoiceLineItemAttributes } from 'dashboard/models/invoice';

interface InvoicePendingLineItemsTableProps {
  invoice: Invoice;
}

const InvoicePendingLineItemsTable = ({ invoice }: InvoicePendingLineItemsTableProps) => {
  const currentLineItems =
    invoice.attributes['line-items'] &&
    invoice.attributes['line-items'].map((lineItem: InvoiceLineItemAttributes) => {
      return (
        <TableTR
          key={lineItem['source-id']}
          id={`lineItems-table__row--${lineItem['source-id']}`}
          data-test={`lineItems-table__row--${lineItem['source-id']}`}
        >
          <TableTD>{lineItem.description}</TableTD>
          <TableTD>
            {lineItem['flat-amount-cents']
              ? formatDollar(lineItem['flat-amount-cents'] / 100)
              : '-'}
          </TableTD>
          <TableTD>
            {lineItem['unit-amount-cents']
              ? formatDollar(lineItem['unit-amount-cents'] / 100, 4)
              : '-'}
          </TableTD>
          <TableTD>
            {lineItem['unit-quantity'] ? formatNumber(lineItem['unit-quantity']) : '-'}
          </TableTD>
          <TableTD>{lineItem['amount'] ? formatDollar(lineItem['amount'] / 100) : '-'}</TableTD>
        </TableTR>
      );
    });

  return (
    <>
      <TableLayout
        dataTest='current-usage-table'
        showHeader={true}
        isEmpty={!currentLineItems || currentLineItems.length === 0}
        nullState={
          <TableNullState dataTestBlock='usage-view'>
            <div>
              We&rsquo;re putting the finishing touches on your usage data. We&rsquo;ll populate
              this tab as soon as it&rsquo;s ready.
            </div>
          </TableNullState>
        }
        headerTR={
          <>
            <TableTH data-test='currentLineItems-table__description'>Description</TableTH>
            <TableTH data-test='currentLineItems-table__flat-cost'>Flat Cost</TableTH>
            <TableTH data-test='currentLineItems-table__unit-cost'>Unit Cost</TableTH>
            <TableTH data-test='currentLineItems-table__quantity'>Quantity</TableTH>
            <TableTH data-test='currentLineItems-table__amount'>Amount</TableTH>
          </>
        }
      >
        {currentLineItems}
      </TableLayout>
    </>
  );
};

export default InvoicePendingLineItemsTable;
